import styled, { css } from "styled-components";

export const Section = styled.section`
    background-color: ${p => p.theme.c.light};
    overflow: hidden;
    padding-top: 28px;
    margin-top: -1px;
`;

export const Ribbon = styled.div`
    ${p => p.theme.md.min(css`
        height: 607px;
    `)}

    width: 100%;
    margin-bottom: -243px;
    position: relative;

    ${p => p.theme.xs(css`
        height: 486px;
        margin-bottom: -30px;
    `)}

    ${p => p.theme.md.only(css`
        margin-bottom: -193px;
        height: 500px;
    `)}

    ${p => p.theme.sm.only(css`
        margin-bottom: -193px;
        height: 500px;
    `)}

    .RibbonWrapper {
        height: 100%;
        z-index: 1;
        position: relative;
    }

    .UpperRibbon {
        position: absolute;
        top: -28px;
        height: 28px;
        background-color: ${p => p.theme.c.info};
        width: 100%;
        transform: skewY(5.9deg);
        transform-origin: top left;

        ${p => p.theme.xs(css`
            height: 100px;
            transform: none;
        `)}
    }

    .LowerShadow {
        position: absolute;
        top: 268px;
        height: 5px;
        box-shadow: 0 2px 16px 4px ${p => p.theme.c.blackShadow4};
        width: 100%;
        transform: skewY(15.7deg);
        transform-origin: top left;

        ${p => p.theme.md.only(css`
            top: 219px;
        `)}

        ${p => p.theme.sm.only(css`
            top: 220px;
            transform: skewY(20.05deg);
        `)}

        ${p => p.theme.xs(css`
            bottom: 61px;
            top: auto;
        `)}
    }

    h3, p {
        margin: 0;
    }
    h3 {
        font-size: 28px;
        color: ${p => p.theme.c.info};
        font-weight: 400;
        margin-bottom: 8px;

        ${p => p.theme.md.only(css`
            font-size: 24px;
            margin-bottom: 4px;
        `)}

        ${p => p.theme.sm.only(css`
            font-size: 24px;
            margin-bottom: 4px;
        `)}

        ${p => p.theme.xs(css`
            font-size: 20px;
            margin-bottom: 4px;
        `)}
    }
    p {
        font-size: 24px;
        line-height: 1.5;
        color: ${p => p.theme.c.snow};
        font-weight: 300;
        text-align: justify;

        ${p => p.theme.md.only(css`
            font-size: 20px;
        `)}

        ${p => p.theme.sm.only(css`
            font-size: 18px;
        `)}

        ${p => p.theme.xs(css`
            font-size: 17px;
        `)}
    }


    .Container {
        position: relative;
        width: 412px;
        z-index: 5;

        ${p => p.theme.md.only(css`
            width: 350px;
        `)}

        ${p => p.theme.sm.only(css`
            width: 300px;
        `)}

        ${p => p.theme.xs(css`
            padding: 16px;
            padding-top: calc(80% - 10px);
            width: auto;
            position: static;
        `)}
    }

    &.Ribbon1 {
        z-index: 3;
        clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 121px - 28px);

        ${p => p.theme.md.only(css`
            clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 101px - 28px);
        `)}

        ${p => p.theme.sm.only(css`
            clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 50px);
        `)}

        ${p => p.theme.xs(css`
            clip-path: polygon(0 -28px, 0 100%, calc(100% + 1px) 105%, calc(100% + 1px) 8px);
        `)}
        .RibbonWrapper {
            clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 121px);
            ${p => p.theme.md.only(css`
                clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 101px);
            `)}

            ${p => p.theme.sm.only(css`
                clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 76px);
            `)}

            ${p => p.theme.xs(css`
                clip-path: polygon(0 0, 0 427px, calc(100% + 1px) 100%, calc(100% + 1px) 36px);
            `)}
            background-color: ${p => p.theme.c.boost};
        }
        .Container {
            top: 84px;
            left: 120px;

            ${p => p.theme.md.only(css`
                top: 70px;
                left: 110px;
            `)}

            ${p => p.theme.sm.only(css`
                top: 56px;
                left: 37px;
            `)}

            ${p => p.theme.xs(css`
                @media screen and (min-width: 380px) {
                    padding-top: 270px;
                }
            `)}
        }
        img {
            width: 832px;
            position: absolute;
            right: -30px;
            top: 52px;
            mask-image: -webkit-gradient(linear, left 70%, right bottom,
                       color-stop(0.15,  transparent),
                       color-stop(0.3,  ${p => p.theme.c.black}),
                       color-stop(1.00,  ${p => p.theme.c.black}));
            &.Firefox {
                mask-image: -webkit-gradient(linear, left bottom, right bottom, color-stop(0.13, transparent), color-stop(0.35, black), color-stop(1, black));
                ${p => p.theme.xs(css`
                    mask-image: -webkit-gradient(
                        linear,
                        left bottom,
                        left top,
                        color-stop(0.2, transparent),
                        color-stop(0.35, black),
                        color-stop(1, black)
                    );
                `)}
            }


            ${p => p.theme.md.only(css`
                width: 665px;
                right: -22px;
                top: 50px;
            `)}

            ${p => p.theme.sm.only(css`
                width: 705px;
                right: -22px;
                top: 23px;
                mask-image: -webkit-gradient(
                    linear,
                    left 70%,
                    right bottom,
                    color-stop(0.3, transparent),
                    color-stop(0.45, ${p => p.theme.c.black}),
                    color-stop(1, ${p => p.theme.c.black})
                );
            `)}

            ${p => p.theme.xs(css`
                width: 100%;
                max-width: 400px;
                right: 0;
                top: 0;
                clip-path: none;
                mask-image: -webkit-gradient(
                    linear,
                    3% 84%,
                    11% top,
                    color-stop(0.1, transparent),
                    color-stop(0.2, black),
                    color-stop(1, black)
                );

                @media screen and (min-width: 400px) {
                    right: auto;
                    left: calc((100vw - 400px) / 2);
                    border-right: 9px solid ${p => p.theme.c.info};
                    border-left: 9px solid ${p => p.theme.c.info};
                    box-sizing: border-box;
                }
            `)}

        }
    }

    &.Ribbon2 {
        z-index: 2;
        clip-path: polygon(0 121px - 28px, 0 105%, calc(100% + 1px) 50%, calc(100% + 1px) 0 - 28px);

        ${p => p.theme.md.only(css`
            clip-path: polygon(0 101px - 28px, 0 105%, calc(100% + 1px) 50%, calc(100% + 1px) 0 - 28px);
        `)}

        ${p => p.theme.sm.only(css`
            clip-path: polygon(0 101px - 28px, 0 105%, calc(100% + 1px) 50%, calc(100% + 1px) 0 - 28px);
        `)}

        ${p => p.theme.xs(css`
            clip-path: polygon(0 3px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -36px);
        `)}

        .RibbonWrapper {
            clip-path: polygon(0 121px, 0 100%, calc(100% + 1px) 45%, calc(100% + 1px) 0);
            ${p => p.theme.md.only(css`
                clip-path: polygon(0 101px, 0 100%, calc(100% + 1px) 45%, calc(100% + 1px) 0);
            `)}

            ${p => p.theme.sm.only(css`
                clip-path: polygon(0 101px, 0 100%, calc(100% + 1px) 45%, calc(100% + 1px) 0);
            `)}

            ${p => p.theme.xs(css`
                clip-path: polygon(0 36px, 0 100%, calc(100% + 1px) calc(100% - 60px), calc(100% + 1px) 0);
            `)}
            background-color: ${p => p.theme.c.pale};
        }
        .UpperRibbon {
            transform: skewY(-5.9deg);
            transform-origin: top right;
            ${p => p.theme.xs(css`
                height: 100px;
                transform: none;
            `)}

            ${p => p.theme.sm.only(css`
                transform: skewY(-7.7deg);
            `)}
        }

        .LowerShadow {
            transform: skewY(-15.75deg);
            transform-origin: top right;
            ${p => p.theme.sm.only(css`
                top: 220px;
                transform: skewY(-20.05deg);
            `)}
            ${p => p.theme.xs(css`
                bottom: 60px;
                top: auto;
            `)}
        }
        p, h3 {
            color: ${p => p.theme.c.dark};
        }

        .Container {
            top: 169px;
            left: 300px;

            ${p => p.theme.md.only(css`
                top: 149px;
                left: 270px;
            `)}

            ${p => p.theme.sm.only(css`
                top: 149px;
                left: 230px;
            `)}

            ${p => p.theme.xs(css`
                padding-top: 60px;
            `)}
        }

        img {
            position: absolute;
            pointer-events: none;
            width: 477px;
            left: -82px;
            top: 162px;
            ${p => p.theme.md.only(css`
                width: 423px;
                left: -73px;
                top: 111px;
            `)}

            ${p => p.theme.sm.only(css`
                width: 383px;
                left: -75px;
                top: 144px;
            `)}

            ${p => p.theme.xs(css`
                width: 350px;
                left: calc((100% - 350px) / 2);
                top: 174px;
            `)}
        }
    }

    &.Ribbon3 {
        z-index: 1;
        pointer-events: none;
        clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 121px - 28px);

        ${p => p.theme.md.only(css`
            clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 101px - 28px);
        `)}

        ${p => p.theme.sm.only(css`
            clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 50px);
        `)}

        ${p => p.theme.xs(css`
            clip-path: polygon(0 -28px, 0 100%, calc(100% + 1px) 105%, calc(100% + 1px) 8px);
        `)}

        .RibbonWrapper {
            clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 121px);
            ${p => p.theme.md.only(css`
                clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 101px);
            `)}

            ${p => p.theme.sm.only(css`
                clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 76px);
            `)}

            ${p => p.theme.xs(css`
                clip-path: polygon(0 0, 0 427px, calc(100% + 1px) 100%, calc(100% + 1px) 36px);
            `)}
            background-color: ${p => p.theme.c.boost};
        }
        .Container {
            top: 131px;
            left: 409px;

            height: 200px;
            display: flex;
            ${p => p.theme.sm.min(css`
                justify-content: center;
            `)}
            flex-direction: column;

            ${p => p.theme.lg(css`
                height: 230px;
            `)}

            ${p => p.theme.md.only(css`
                top: 111px;
                left: 369px;
            `)}

            ${p => p.theme.sm.only(css`
                top: 110px;
                left: 225px;
                height: 190px;
            `)}

            ${p => p.theme.xs(css`
                padding-top: 50px;

                h3 {
                    text-align: left;
                }
            `)}
        }

        h3 {
            text-align: right;
        }
        img {
            position: absolute;
            pointer-events: none;
            transform: rotate(10deg);
            width: 682px;
            right: -56px;
            top: 109px;
            clip-path: polygon(266px 6.3px, 487px 9.7px, 630px 439.2px, 211px 397.6px);
            ${p => p.theme.md.only(css`
                width: 515px;
                right: -56px;
                top: 124px;
                clip-path: polygon(203px 6.3px, 487px 9.7px, 630px 439.2px, 141px 397.6px);
            `)}

            ${p => p.theme.sm.only(css`
                width: 485px;
                right: -56px;
                top: 132px;
                clip-path: polygon(203px 6.3px, 487px 9.7px, 630px 439.2px, 141px 397.6px);
            `)}

            ${p => p.theme.xs(css`
                width: 421px;
                right: calc((100% - 421px) / 2);
                top: 190px;
                transform: rotate(4deg);
                clip-path: none;
            `)}
        }
    }

    &.Ribbon4 {
        z-index: 0;
        background-color: ${p => p.theme.c.pale};


        clip-path: polygon(0 95px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -28px);

        height: 310px;
        ${p => p.theme.md.only(css`
            clip-path: polygon(0 74px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -28px);
        `)}

        ${p => p.theme.sm.only(css`
            clip-path: polygon(0 74px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -28px);
        `)}
        ${p => p.theme.xs(css`
            clip-path: polygon(0 3px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -36px);
            height: 200px;
        `)}

        .RibbonWrapper {
            background-color: ${p => p.theme.c.pale};
            ${p => p.theme.xs(css`
                clip-path: polygon(0 36px, 0 100%, calc(100% + 1px) 100%, calc(100% + 1px) 0);
            `)}
        }
        .UpperRibbon {
            top: -27px;
            transform: skewY(-5.9deg);
            transform-origin: top right;
            z-index: 1;
            ${p => p.theme.sm.only(css`
                transform: skewY(-7.7deg);
            `)}

            ${p => p.theme.xs(css`
                top: -28px;
                transform: none;
                z-index: 0;
            `)}

        }

        margin-bottom: 0;


        p {
            margin-top: 0;
            padding-top: 167px;
            color: ${p => p.theme.c.dark};
            font-weight: 400;
            font-variant: small-caps;
            margin-bottom: 20px;

            ${p => p.theme.xs(css`
                padding: 16px;
                padding-top: 50px;
                margin-bottom: 0;
            `)}
        }
        p, div {
            text-align: center;

        }
    }
`;

export const ComingSoon = styled.div`
    position: absolute;
    top: 200px;
    right: 0;
    background-color: ${p => p.theme.c.info};
    color: white;
    font-size: 26px;
    font-weight: 400;
    padding: 10px 24px;
    box-shadow: 5px 5px 6px 0 rgba(0, 0, 0, 0.17);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    border-radius: 8px 0 0 8px;
    ${p => p.theme.sm.max(css`
        font-size: 22px;
        padding: 8px 16px;
        border-radius: 8px;
    `)}
    ${p => p.theme.xs(css`
        left: 20px;
        right: 20px;
        top: 280px;
        text-align: center;
    `)}
`;